export const PARAMETER_STATE = 'parameters'
export const FUNCTION_STATE = 'functions'
export const VARIABLE_STATE = 'variables'
export const SCOPE_STATE = 'scopes'
export const GROUP_TYPE_STATE = 'group_types'
export const GROUP_STATE = 'groups'
export const FILTERS_STATE = 'filters'
export const ALGORITHM_INPUT_VARS = 'algorithm_input_vars'
export const PRICE_TYPES_STATE = 'price_types_state'
export const CONCURRENT_PRICE_TYPE_STATE = 'concurrent_price_types_state'
export const CONCURRENT_TYPE_STATE = 'concurrent_type_state'
export const REGION_STATE = 'region_state'
export const OBJECT_TYPES_STATE = 'object_types'
export const CONCURRENT_STATE = 'concurrent'
export const CONCURRENT_REGION_STATE = 'concurrent_region'
export const CONCURRENT_REGION_NAME_STATE = 'concurrent_region_name'
export const PRICE_LEVEL_CALC_FUNCTION_STATE = 'price_level_calc_function'
export const CONCURRENT_PRODUCT_STATUS_STATE = 'concurrent_product_statuses'
export const PRICE_LEVEL_STATE = 'price_level_state'
export const PRICE_TYPE_GROUP_STATE = 'price_type_group'
export const REGION_GROUP_STATE = 'region_group_state'
export const POLITIC_STATE = 'politic_state'
export const USERID_STATE = 'userid'
export const TABLE_STATE = 'table'
export const PERMISSION_STATE = "user_permission"
export const STOCK_STATE = "stock"
export const SUPPLIER_STATE = "supplier"
export const STOCK_LEVEL_CALC_FUNCTION_STATE = 'stock_level_calc_function'
export const STOCK_LEVEL_STATE = 'stock_level_state'
export const CONCURRENT_PRICE_TYPE_NAME_STATE = 'concurrent_price_type_names_state'
export const ALLOCATION_RULE_STATE = 'allocation_rule_state'
export const USER_STATE = 'user'
export const CONCURRENT_PRODUCT_STATUS_NAME_STATE = 'concurrent-region-product-status=name'
export const SELECTED_CORRECTIONS_STATE = 'selected-corrections'
export const CORRECTION_ON_DATE_STATE = 'correction_on_date'
export const CARD_TYPE_STATE = 'card_type'
export const LOYALTY_PARAM_STATE = 'loyalty_param_state'
export const LOYALTY_OBJECT_TYPES_STATE = 'loyalty_object_types_state'
export const ACTIVE_TASK_STATE = 'active-task-state'
export const SHOP_STATE = 'shop-state'
export const SHOWCASE_TYPE_STATE = 'showcase-type-state'
export const SHOWCASE_MODULE_TYPE_STATE = 'showcase-module-type-state'
export const SHOWCASE_STATE = 'showcase'
export const SHOWCASE_TYPE_MODULE_TEMPLATE_STATE = 'showcase_type_module_template'
